import { createCachedSelector, } from 're-reselect';
/**
 * This is the actual function that will get the data from the state and return the data requested. However, this function returns a new
 * object every time which can cause an infinite loop in re-rendering if used in React component. Therefore this function is not EXPORTED
 * and we will create another function below which use memoize to cache the result.
 */
const selectHomeMembersFunc = (membersById, memberIdsByHomeId, homeId) => {
    var _a;
    return (_a = memberIdsByHomeId === null || memberIdsByHomeId === void 0 ? void 0 : memberIdsByHomeId[homeId]) === null || _a === void 0 ? void 0 : _a.reduce((result, id) => {
        const member = membersById[id];
        if (member) {
            return [...result, member];
        }
        return result;
    }, []);
};
/**
 * Select ALL members for a specific home
 */
export const selectHomeMembers = createCachedSelector((state) => { return state.homeMembers.membersById; }, (state) => { return state.homeMembers.memberIdsByHomeId; }, (state, homeId) => { return homeId; }, selectHomeMembersFunc)((state, homeId) => {
    // use homeId as cache key
    return homeId.toString();
});
export const selectHomeMember = (state, memberId) => {
    return state.homeMembers.membersById[memberId];
};
